import type { FormInstance } from "antd/es/form/Form";
import { type FC } from "react";

import type { SiteBatchUpdateEntity } from "src/app/features/Site/types/SiteBatchUpdateEntity";
import { OrgUnitBatchUpdateForm } from "../../../../../components/DrawerForm/BatchUpdateDrawer/OrgUnitBatchUpdateForm";
import { useLoadFormDefinitionQuery } from "../../../../../components/Form/services/server/serverApi";
import type { SearchFormProps } from "../../../../../components/Form/types/types";

type SiteGroupBatchUpdateFormProps = SearchFormProps<SiteBatchUpdateEntity> & { form?: FormInstance };

export const SiteGroupBatchUpdateForm: FC<SiteGroupBatchUpdateFormProps> = ({ searchCallback, form }) => {
    const { data: formDefinition } = useLoadFormDefinitionQuery("site-group");

    return <OrgUnitBatchUpdateForm form={form} searchCallback={searchCallback} formDefinition={formDefinition} />;
};
